import React from 'react';
import { Box, Typography } from '@mui/material';

const listItemStyle = {
    marginBottom: '0.75rem',
};

const ContactSalesSection = () => {
  return (
    <Box sx={{ px: { xs: 2, sm: 4 }, py: 2 }}>
      <Typography paragraph>
        This section allows users to request tailored plans and view community-specific custom plans directly within WatchNod.
      </Typography>

      {/* Contact Sales */}
      <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
        Contact Sales
      </Typography>
      <ul style={{ paddingLeft: '1.25rem' }}>
        <li style={listItemStyle}>
          <Typography variant="body1">
            Users can submit a request form for specific monitoring needs through the Contact Sales option.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1">
            After submission, users receive a confirmation or acknowledgment.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1">
            The WatchNod team reviews the request and contacts the user to understand their requirements. Based on the discussion, a suitable custom plan is created, if applicable.
          </Typography>
        </li>
      </ul>

      {/* Customize Plans Section */}
      <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
        Customize Plans Section
      </Typography>
      <ul style={{ paddingLeft: '1.25rem' }}>
        <li style={listItemStyle}>
          <Typography variant="body1">
            This section displays custom plans created by the WatchNod team based on user requests.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1">
            Plan details include the name, features, duration, pricing, and the number of IPs.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1">
            Users can purchase these custom plans directly from this section.
          </Typography>
        </li>
      </ul>
    </Box>
  );
};

export default ContactSalesSection;
